export default __webpack_public_path__ + "static/media/setion06_kv01_m.95e3cb80.png";